import { cn } from "@/lib/utils";

type CornerFlagProps = {
  tags: string[];
};

export function CornerFlag({ tags }: CornerFlagProps) {
  // Check if New or Updated tags are present
  const hasNew = tags.includes('New');
  const hasUpdated = tags.includes('Updated');

  // Don't render anything if neither tag is present
  if (!hasNew && !hasUpdated) {
    return null;
  }

  // Determine which flag to show (New takes priority)
  const flagType = hasNew ? 'new' : 'updated';
  const flagText = hasNew ? 'NEW' : 'UPDATED';

  return (
    <div className="absolute top-0 right-0 overflow-hidden w-16 h-16 pointer-events-none">
      <div
        className={cn(
          "absolute top-3 -right-7 w-24 text-center transform rotate-45 text-[9px] font-bold tracking-wider py-0.5 shadow-md",
          flagType === 'new'
            ? "bg-lime-500 text-lime-950"
            : "bg-yellow-400 text-yellow-950"
        )}
      >
        {flagText}
      </div>
    </div>
  );
}
